// components
import { Dialog } from 'components/shared';
import AbsenceEmployeeField from 'components/shared/RegisterAbsence/AbsenceEmployeeField';
import Box from '@mui/material/Box';

// hooks
import { useTranslation } from 'react-i18next';

// types
import type { RegisterAbsenceDialogEmployee } from 'components/shared/RegisterAbsence/RegisterAbsenceDialog.types';

type EmployeePickerDialogProps = {
  open: boolean;
  onClose: () => void;
  onSelect: (employee: RegisterAbsenceDialogEmployee) => void;
};

/**
 * Lets the user pick an employee before the Dojo register dialog opens from the
 * general overview. The React dialog asks for the employee itself instead.
 */
const EmployeePickerDialog = ({
  open,
  onClose,
  onSelect
}: EmployeePickerDialogProps) => {
  const { t } = useTranslation('common');

  return (
    <Dialog
      open={open}
      title={t('searchEmployee')}
      handleClose={onClose}
      maxWidth="medium"
      fullWidth
    >
      <Box minHeight={140} pt={1}>
        <AbsenceEmployeeField enabled={open} onSelect={onSelect} />
      </Box>
    </Dialog>
  );
};

export default EmployeePickerDialog;
